var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.937 2.90643H10.9174V2.92609L10.937 2.90643ZM11.9174 7.17884V14.9064H1.91736V3.90643H2.91736V2.90643H1.91736C1.36507 2.90643 0.917358 3.35415 0.917358 3.90643V15.9064C0.917358 16.4587 1.36507 16.9064 1.91736 16.9064H11.9174C12.4696 16.9064 12.9174 16.4587 12.9174 15.9064V6.17884L11.9174 7.17884ZM7.91736 1.90643C7.91736 1.35415 7.46964 0.906433 6.91736 0.906433C6.36507 0.906433 5.91736 1.35415 5.91736 1.90643H4.91736C4.36507 1.90643 3.91736 2.35415 3.91736 2.90643V3.90643H9.91736V2.90643C9.91736 2.35415 9.46964 1.90643 8.91736 1.90643H7.91736Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48667 10.0317L6.62406 11.17L4.91736 11.7396L5.48667 10.0317ZM12.3176 3.20002L13.4562 4.33858L7.19522 10.6003L6.05666 9.46174L12.3176 3.20002ZM14.1057 1.95113L14.7058 2.55123C14.8545 2.69993 14.8545 2.94104 14.7058 3.08974L14.0258 3.76893L12.8873 2.63036L13.5672 1.95113C13.7159 1.80242 13.957 1.80242 14.1057 1.95113Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardFill);
export default __webpack_public_path__ + "static/media/clipboard-fill.69e45368.svg";
export { ForwardRef as ReactComponent };